import { Box, Container, Grid, Stack, Typography } from "@mui/material";
import PartnershipForm from "../../../components/partnership-form/PartnershipForm";

type PartnershipCard = {
  title: string;
  description: string;
  icon: string;
};

const cards: PartnershipCard[] = [
  {
    title: "Technology Partners",
    description:
      "We collaborate with tech providers to create integrated solutions that expand functionality and drive innovation.",
    icon: "/images/home/partnership-technology_icon.png",
  },
  {
    title: "Implementation Partners",
    description:
      "Experts who bring our solutions to life—ensuring successful deployment, configuration, and customer adoption.",
    icon: "/images/home/partnership-implementation_icon.png",
  },
  {
    title: "Investors",
    description:
      "Strategic partners who believe in our vision and support our growth through financial and advisory engagement.",
    icon: "/images/home/partnership-investor_icon.png",
  },
  {
    title: "System Integrators",
    description:
      "Organizations that design, build, and manage complex IT systems by integrating our products into their architecture.",
    icon: "/images/home/partnership-system_icon.png",
  },
];

export default function Partnership() {
  return (
    <Box
      id="partnership"
      sx={{
        py: { xs: 6, md: 10 },
        bgcolor: "#F5FAFF",
        scrollMarginTop: { xs: 0 },
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          fontWeight={800}
          sx={{
            textAlign: "center",
            mb: { xs: 4, md: 4 },
            mx: { xs: 1, md: 35 },
            color: "#1e293b",
            fontSize: { xs: "36px", md: "48px" },
            lineHeight: 1.2,
          }}
        >
          Let’s Grow Together Through Partnership
        </Typography>

        <Grid container spacing={{ xs: 3, md: 10 }} alignItems="center">
          <Grid size={{ xs: 12, md: 6 }}>
            <Box
              component="img"
              src="/images/home/partnership.png"
              alt="Partnership"
              loading="lazy"
              sx={{
                display: "block",
                objectFit: "contain",
                width: "100%",
                height: "100%",
                marginBottom: { xs: "20px", md: "50px" },
              }}
            />

            <Typography
              sx={{
                color: "#646464",
                textAlign: "left",
                fontSize: { xs: 25, md: 22 },
                lineHeight: "33.5px",
              }}
            >
              We collaborate with technology providers, implementation experts,
              investors, and system integrators to create value and scale
              innovation.
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Stack spacing={4}>
              {cards.map((p, index) => (
                <Box
                  key={index}
                  sx={{
                    width: { xs: "100%" },
                    bgcolor: "white",
                    borderRadius: "15px",
                    p: "30px",
                    boxShadow:
                      "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)",
                    textAlign: { xs: "left", md: "left" },
                  }}
                >
                  <Stack
                    direction="row"
                    sx={{ gap: "30px" }}
                    alignItems="center"
                  >
                    <Box
                      sx={{
                        width: 60,
                        height: 60,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <Box
                        component="img"
                        loading="lazy"
                        alt={p.title}
                        src={p.icon}
                        sx={{
                          width: 60,
                          height: 60,
                        }}
                      />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        sx={{
                          color: "#313131",
                          mb: "15px",
                          fontSize: "25px",
                          lineHeight: "29px",
                          fontWeight: 600,
                        }}
                      >
                        {p.title}
                      </Typography>
                      <Typography
                        sx={{
                          color: "#5E5E5E",
                          lineHeight: 1.5,
                          fontSize: "18px",
                          letterSpacing: "0.02em",
                        }}
                      >
                        {p.description}
                      </Typography>
                    </Box>
                  </Stack>
                </Box>
              ))}
            </Stack>
          </Grid>
        </Grid>
        <PartnershipForm />
      </Container>
    </Box>
  );
}
